import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

import _ from 'lodash';

export const createHttpProvider = (
  baseUrl: string,
  authenticationFailureHandler: (status: number) => void = _.noop,
  withCredentials = true
): AxiosInstance =>
  _.tap(
    axios.create({ baseURL: baseUrl, withCredentials, timeout: 15000 }),
    (axiosInstance: AxiosInstance) =>
      axiosInstance.interceptors.response.use(
        (response: AxiosResponse) => response.data,
        (error: AxiosError) => {
          if (error.response) {
            const { status } = error.response;
            if (_.includes([401, 403], status)) {
              return authenticationFailureHandler(status);
            }
          }
          console.log(error);
          throw error;
        }
      )
  );
